import React, { FunctionComponent, SVGProps } from 'react';

type SVGRProps = {
  alt?: string;
};

export const BrainRightIcon: FunctionComponent<SVGProps<SVGSVGElement> & SVGRProps> = (props) => (
  <svg
    width={25}
    height={50}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 250 500"
    {...props}
  >
    <path
      // eslint-disable-next-line max-len
      d="M.967 0v485.525c32.178.46 64.127-5.48 93.99-17.473a242.839 242.839 0 0 0 79.961-52.39 242.774 242.774 0 0 0 72.357-172.9 242.774 242.774 0 0 0-72.357-172.9A242.876 242.876 0 0 0 .967 0Z"
      fill="#000"
    />
  </svg>
);
